import { Route, Switch, useRouteMatch } from "react-router-dom";

import { isAdminVar, isManagerVar } from "@cache/cache";
import useDocumentTitle from "@components/use-document-title/use-document-title";

import CompliancePrograms from "../programs/components/compliance-programs";
import ComplianceProgram from "./components/compliance-program";
import ComplianceProgramForm from "./components/compliance-program-form/compliance-program-form";

const Programs = () => {
  useDocumentTitle("Programs");
  const { path } = useRouteMatch();
  const isAdmin = isAdminVar();
  const isManager = isManagerVar();

  return (
    <Switch>
      <Route exact path={path}>
        <CompliancePrograms />
      </Route>
      <Route
        exact
        path={[
          `${path}/:complianceProgramId(\\d+)`,
          `${path}/:complianceProgramId(\\d+)/actions`,
          `${path}/:complianceProgramId(\\d+)/reminders`,
          `${path}/:complianceProgramId(\\d+)/progress`,
          `${path}/:complianceProgramId(\\d+)/reporting/:reportTab?`,
        ]}
      >
        <ComplianceProgram />
      </Route>
      {(isAdmin || isManager) && (
        <Route
          exact
          path={[
            `${path}/new`,
            `${path}/:complianceProgramId(\\d+)/edit`,
            `${path}/:complianceProgramId(\\d+)/duplicate`,
          ]}
        >
          <ComplianceProgramForm />
        </Route>
      )}
    </Switch>
  );
};

export default Programs;
